export var TARIFF_GROUP = /*#__PURE__*/function (TARIFF_GROUP) {
  TARIFF_GROUP["homeInternet"] = "homeInternet";
  TARIFF_GROUP["homeInternetAndTv"] = "homeInternetAndTv";
  TARIFF_GROUP["homeInternetTvAndMobile"] = "homeInternetTvAndMobile";
  TARIFF_GROUP["presetUp"] = "presetUp";
  return TARIFF_GROUP;
}({});
export var PRESET_FORM_BASE_URL = '/customers/products/mobile/convorder';
export var DEVICE_TAB_TYPE = /*#__PURE__*/function (DEVICE_TAB_TYPE) {
  DEVICE_TAB_TYPE[DEVICE_TAB_TYPE["deviceDocumentation"] = 3] = "deviceDocumentation";
  DEVICE_TAB_TYPE[DEVICE_TAB_TYPE["deviceInformation"] = 1] = "deviceInformation";
  DEVICE_TAB_TYPE[DEVICE_TAB_TYPE["deviceParameters"] = 2] = "deviceParameters";
  return DEVICE_TAB_TYPE;
}({});
export var DEVICE_CARD_SIZE = /*#__PURE__*/function (DEVICE_CARD_SIZE) {
  DEVICE_CARD_SIZE["large"] = "large";
  DEVICE_CARD_SIZE["medium"] = "medium";
  DEVICE_CARD_SIZE["small"] = "small";
  return DEVICE_CARD_SIZE;
}({});
export var DEVICE_TYPE = /*#__PURE__*/function (DEVICE_TYPE) {
  DEVICE_TYPE["router"] = "router";
  DEVICE_TYPE["tvConsole"] = "tvConsole";
  return DEVICE_TYPE;
}({});
export var PAGE_TYPE_EVENT_NAMES = /*#__PURE__*/function (PAGE_TYPE_EVENT_NAMES) {
  PAGE_TYPE_EVENT_NAMES["fmc"] = "fmc_page_ev_";
  PAGE_TYPE_EVENT_NAMES["fttb"] = "fttb_page_ev_";
  PAGE_TYPE_EVENT_NAMES["fttb_kit"] = "fttb-kit_page_ev_";
  PAGE_TYPE_EVENT_NAMES["fttb_net"] = "fttb-net_page_ev_";
  return PAGE_TYPE_EVENT_NAMES;
}({});
export var PAGE_TYPE_EVENTS = {
  fmc: 'fmc_ev_',
  fttb: 'fttb_ev_',
  fttb_kit: 'fttb_net_ev_',
  fttb_net: 'fttb_kit_ev_'
};
export var PAGE_TYPES = /*#__PURE__*/function (PAGE_TYPES) {
  PAGE_TYPES["fmc"] = "fmc";
  return PAGE_TYPES;
}({});
export var currentStateList = {
  abbreviated: 'abbreviated',
  captcha: 'captcha',
  fail: 'fail',
  loading: 'loading',
  none: 'none',
  requestForm: 'requestForm',
  success: 'success'
};
export var tariffValueGroup = {
  home: 'home',
  mobile: 'mobile'
};
export var tariffValueKind = {
  speed: 'speed',
  channels: 'channels',
  internet: 'internet',
  minutes: 'minutes',
  group: 'mobile',
  kind: 'internet'
};